export default function FormLabel({ children, isRequired, ...props }) {
  return (
    <label className="text-neutral-700" {...props}>
      {children}
      {isRequired && <span className="text-red-500"> *</span>}
    </label>
  );
}
